export {
  useExtensionsSideloading,
  type UseExtensionsSideloadingResult,
} from './useExtensionsSideloading';
